import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/logo.svg'
import _imports_1 from '@/assets/img/logo/searchIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-26e89a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mx-auto w-full fixed top-0 left-0 right-0 justify-center items-center h-16 bg-white z-50 shadow-sm",
  style: {"z-index":"500"}
}
const _hoisted_2 = { class: "mx-auto h-16 flex items-center lg:px-0 lg:w-[1024px] w-full px-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-full"
}, null, -1))
const _hoisted_4 = { class: "justify-center items-center w-full pt-2 h-8 text-base flex font-semibold text-[#3d3d3d] hover:text-zinc-400 mr-6 sm:mr-4" }
const _hoisted_5 = { class: "justify-center items-center w-full pt-2 h-8 text-base flex font-semibold text-[#3d3d3d] hover:text-zinc-400 mr-6 sm:mr-4" }
const _hoisted_6 = { class: "relative hidden md:flex ml-auto flex-col" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-full h-full object-cover",
  src: _imports_1,
  alt: "Search"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "absolute top-12 bg-zinc-50 w-56 max-h-28 left-3 overflow-y-scroll text-xs"
}
const _hoisted_11 = ["onMousedown"]
const _hoisted_12 = { class: "relative hidden md:flex" }
const _hoisted_13 = {
  key: 0,
  class: "relative"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }

import {ref, computed,  onMounted} from 'vue';
import { useStore } from 'vuex';
import GoogleLogin from '../Main/GoogleLoginBtn.vue';
import ProfileDiv from '../UI/ProfileDiv.vue';
import { isTokenValid } from '@/utils/Functions';
import { useRoute, useRouter } from 'vue-router';
import { initFilter } from '@/utils/findCategory';
import { debounce } from 'lodash';
import agreeBox from '../UI/agreeBox.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavigator',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const searchTitle = ref('');
const compareList = ['크레스티드 게코', '가고일 게코', '리키에너스 게코', '차화 게코', '레오파드 게코', '납테일 게코', '펫테일 게코', '토케이 게코', 
'비어디 드래곤', '모니터/테구', '스킨크', '이구아나', '기타 도마뱀', '볼파이톤', '파이톤/보아', '킹/밀크스네이크', '호그노즈', '콘스네이크', '수생/반수생 거북', '습지 거북', '육지 거북', '테라핀',
'뉴트', '살라만다', '토드', '프록', '등각류', '타란튤라', '센티페드', '전갈', '밀리페드', '사육장', '먹이', '기타 용품', '도서' ];
const autoCompleteArr = ref(compareList);

const welcome = computed(()=> store.state.welcome)
const handlePopup = () => {
    store.commit('IS_WELCOME', false)
}
const loggedIn = computed(() => isTokenValid());
const isFocused = ref(false)
const whereIam = (path) => {
    return route.path.includes(path)
}
const handleSearch = debounce((value) => {
    const lowerCaseValue = value.toLowerCase();
    const result = compareList.filter((c) => c.toLowerCase().includes(lowerCaseValue));
    autoCompleteArr.value = result;
}, 150); 
const goToReptile = () =>{
    store.commit('SET_CURRENT_STATUS', 0)
    store.commit('SET_CURRENT_LIST', store.state.reptileList)
    initFilter(store);
    router.push('/reptile');
}
const selectedItem = (item) => {
    if(compareList.find((c) => c === item)){
        return true
    } else {
        return false;
    }
}
const clickCompleteList = (value) => {
    searchTitle.value = value;
}


const searchBtn = async () => {
    if(!searchTitle.value) {
        return ;
    }
    initFilter(store);
    store.commit('SET_SPECIES_STATUS', searchTitle.value)
    // store.commit('SET_SPECIES_STATUS', null)
    await store.dispatch('fetchFilterData');
    router.push('/reptile')
    searchTitle.value= null;
    // console.log(searchTitle.value)
}
// 검색창으로 title 검색하기 
// const searchBtn = async () => {
//     if(!searchTitle.value) {
//         return ;
//     }
//     initFilter(store);
//     store.commit('SET_KEYWORD_STATUS', searchTitle.value)
//     store.commit('SET_SPECIES_STATUS', null)
//     await store.dispatch('fetchFilterData');
//     router.push('/reptile')
//     searchTitle.value= null;
//     // console.log(searchTitle.value)
// }



const deleteBtn = () => {
    searchTitle.value = '';
}




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "flex justify-center items-center w-16 h-9 text-xs mr-8",
        to: '/'
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: '/reptile',
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "justify-center items-center w-full pt-2 h-8 text-base flex font-semibold text-[#3d3d3d] hover:text-zinc-400 mr-6 sm:mr-4",
            onClick: goToReptile
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["notHere", { 'here' : whereIam('/reptile') }])
            }, "분양", 2)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: '/community' }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["notHere", { 'here' : whereIam('/community') || whereIam('/qna') || whereIam('/gallery')  }])
            }, "커뮤니티", 2)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: '/news/event' }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["notHere", { 'here' : whereIam('/news') }])
            }, "정보", 2)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "searchInput w-64 bg-[#F5F7F9] h-9 rounded-3xl ml-auto mr-4 px-4 placeholder:text-xs text-xs",
          placeholder: "파충류 종을 검색해봐요!",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleSearch)(($event.target as HTMLInputElement).value))),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (isFocused.value = true)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (isFocused.value = false)),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTitle).value = $event)),
          onKeypress: _withKeys(searchBtn, ["enter"])
        }, null, 544), [
          [_vModelText, searchTitle.value]
        ]),
        _createElementVNode("button", {
          class: "absolute right-7 bottom-[10px] w-4 h-4 flex items-center",
          onClick: searchBtn,
          disabled: !selectedItem(searchTitle.value)
        }, _hoisted_9, 8, _hoisted_7),
        (isFocused.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(autoCompleteArr.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  onMousedown: ($event: any) => (clickCompleteList(item)),
                  class: "px-2 py-2 cursor-pointer hover:bg-zinc-200"
                }, _toDisplayString(item), 41, _hoisted_11))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (loggedIn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(ProfileDiv)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(GoogleLogin)
            ]))
      ])
    ]),
    (welcome.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(agreeBox, { onClosePopup: handlePopup })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})